var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentDetails"},[_c('NavBar',{attrs:{"navBlock":_vm.navBlock,"navtitle":_vm.navtitle,"pageBack":true}}),_vm._v(" "),_c('div',{staticClass:"detailsContent"},[_c('Goods',{attrs:{"type":_vm.type,"id":_vm.id}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-054777de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/market/memberGoods/addMemberGoods.vue
// module id = null
// module chunks = 